import { render, staticRenderFns } from "./Inform.vue?vue&type=template&id=7033eb16&scoped=true&"
import script from "./Inform.vue?vue&type=script&lang=js&"
export * from "./Inform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7033eb16",
  null
  
)

export default component.exports